import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Headbar = _resolveComponent("Headbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ModalPrompt = _resolveComponent("ModalPrompt")!
  const _component_NLoadingBarProvider = _resolveComponent("NLoadingBarProvider")!
  const _component_NNotificationProvider = _resolveComponent("NNotificationProvider")!
  const _component_NConfigProvider = _resolveComponent("NConfigProvider")!

  return (_openBlock(), _createBlock(_component_NConfigProvider, {
    "theme-overrides": _ctx.themeOverride,
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_NNotificationProvider, { max: 3 }, {
        default: _withCtx(() => [
          _createVNode(_component_NLoadingBarProvider, null, {
            default: _withCtx(() => [
              (_ctx.showHeadbar)
                ? (_openBlock(), _createBlock(_component_Headbar, { key: 0 }))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_router_view),
              _createVNode(_component_Footer),
              _createVNode(_component_ModalPrompt)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["theme-overrides"]))
}